import {
    additionalFieldTranslations,
    eventTranslations,
    locationTranslations,
    unitTranslations
} from "./Modules/SimplyBook/API/types";
import "element-internals-polyfill";

import "./Components/Form";

import "./Shopify/global";
import "./Utils/Number";
import "./Utils/LineClampDetect";
import "./Utils/CSS";
import "./Utils/String";
import "./Utils/QueryParams";
import "./Components/Accordion/Box.js";
import "./Components/Scroller/ScrollerNav";
import "./Components/Scroller/TilesLoader";
import "./Components/vendor/Shopify/share";
import "./Modules/Header/Navigation";
import "./Modules/Header/MiniCart";
import "./Modules/Header/LanguageSelector";
import "./Components/Gallery";
import "./Components/Image360";
import "./Effects/StickyOnScroll";
import "./Effects/AnimateReadMore";
import "./Modules/Filters/FilterSidebar";
import "./Modules/Filters/PriceRange";
import "./Modules/Product/Configurator";
import "./Modules/Product/RentalConfigurator";
import "./Modules/Product/Quantity";
import "./Modules/Product/LocationDropdownButton";
import "./Modules/SimplyBook";
import "./Utils/ScrollTop";
import "./Utils/Holidays";
import "./Utils/ExternalLinks";
import "./Utils/Elements";
import "./Modules/Tabbed";
import "./Modules/Account/AddressForms";
import "./Modules/Account/Register";
import "./Modules/Sale/";
import "./Modules/RentalAndAppointments/";
import "./Modules/RentalAndAppointments/PDP/DateRangePicker";
import "./Modules/RentalAndAppointments/PDP/DateRangePickerEbike";
import "./Modules/ShowThis";
import "./Components/Hero/Filter";
import "./Components/DateRangePicker";
import "./Modules/Search";
import "./Modules/RateCalculator";
import "./Modules/LoaderOverlay";

import "./Modules/Cart/CartManager";
import "./Modules/Cart/CartFlowController";
import "./Modules/Cart/Reservation";
import "./Modules/Cart/GiftManager";

import "./Modules/VehicleRequest";

import "./Modules/MessageHandlers";

import { Toast } from "./Components/Dialog/Toast";
import { Modal } from "./Components/Dialog/Modal";
import { Reveal } from "./Components/Dialog/Reveal";
import "./Components/Dialog/DialogListener";

declare global {
    interface Window {
        sbi18n: {
            events: eventTranslations;
            additional_fields: additionalFieldTranslations;
            locations: locationTranslations;
            units: unitTranslations;
        };
        Shopify: any;
        cartManager: any;
        accessibilityStrings: { [key: string]: string };
        ValidityMessages: { [key: string]: { [key: string]: string } };
        SuccessMessages: { [key: string]: { [key: string]: string } };
        Toast: typeof Toast;
        Modal: typeof Modal;
        Reveal: typeof Reveal;
        routes: { [key: string]: string };
        i18n: { [key: string]: { [key: string]: string } };
        datePicker: { [key: string]: string };
    }

    /**
     * window.Shopify is added by Shopify... no way around it
     * cartManager is added for the moment for convenient testing, maybe it stays globally available. Can be imported anyways...
     */
}

window.Toast = Toast;
window.Modal = Modal;
window.Reveal = Reveal;
